module.exports = __webpack_public_path__ + "static/media/logout.2b7c22a3.svg";